import Button from "../../components/Button";
import typography from "../../helpers/typography";

const NotFound = () => {
  return (
    <div className="2xl:container 2xl:mx-auto text-center flex flex-col items-center my-10 md:my-10 p-1">
      <p className="text-artfulRed font-semibold mb-2">404</p>
      <h1 className={typography.sizes.h1}>Page not found.</h1>
      <p className="font-poppins my-4 text-sm text-zinc-500">Please check the URL in the address bar and try again.</p>
      <Button
        to="/"
        text="Go back home"
        icon="right-arrow"
      />
    </div>
  )
};

export default NotFound;
